import React from 'react'
import {Box, Flex} from '@chakra-ui/layout'
import PropTypes from 'prop-types'
import usePHPBKApi from '../../../custom-api/hooks/use-phpkb-api'
import {remCalc} from '../../../theme/_utils'
import {useIntl} from 'react-intl'
import {Link as RouteLink} from 'react-router-dom'

import {AccordionBlock} from '../../../components/editorial-components'
import {Button} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const FaqSection = React.forwardRef(({query}, ref) => {
    const intl = useIntl()
    const {buildUrl} = useMultiSite()

    const {usePHPBKFreeTextSearch} = usePHPBKApi()
    const {data} = usePHPBKFreeTextSearch({q: query, limit: 4}, {enabled: !!query})

    const faqItems =
        data?.hits?.hits?.map((hit) => ({
            accordion_title: hit?._source?.article_title,
            paragraph: hit?._source?.article_content,
            accordion_title_font_size: 'Big',
        })) || []

    if (!faqItems || faqItems.length === 0) return null

    return (
        <Box ref={ref}>
            <AccordionBlock
                items={faqItems}
                variant="White"
                enableContrasted
                noPadding
                isEditorial={true}
                title={intl.formatMessage({
                    defaultMessage: 'FAQ',
                    id: 'paperless.faq.title',
                })}
            />
            <Flex justifyContent="center" pt={remCalc(16)}>
                <Button
                    as={RouteLink}
                    to={buildUrl(`/faqs/search?q=${query}`)}
                    variant="secondary"
                    mx={'auto'}
                    width={{base: remCalc(228), md: remCalc(332)}}
                >
                    {intl.formatMessage({
                        defaultMessage: 'Discover more',
                        id: 'paperless.faq.discover_more',
                    })}
                </Button>
            </Flex>
        </Box>
    )
})

FaqSection.displayName = 'FaqSection'

FaqSection.propTypes = {
    articles: PropTypes.array,
    query: PropTypes.string,
}

export default FaqSection
